import * as t from "io-ts";
import { decimal } from "./index";
import nullable from "./nullable";
import { isoDateTime } from "./date-time";
const extraCO2TypeUnitT = t.union([
    t.literal("KG"),
    t.literal("HOURS"),
    t.literal("ITEM"),
]);
export const extraCo2TypeReqBodyT = t.strict({
    name: t.string,
    unit: extraCO2TypeUnitT,
    value: decimal,
});
export const extraCO2TypeT = t.intersection([
    extraCo2TypeReqBodyT,
    t.strict({
        id: t.string,
        orgId: t.string,
        deletedAt: nullable(isoDateTime),
    }),
]);
export const extraCO2TypesT = t.array(extraCO2TypeT);
export const extraCo2TypeUsageT = t.strict({
    ordersCount: t.number,
    clientCargoTemplates: t.array(t.strict({
        id: t.string,
        clientId: t.string,
        clientName: t.string,
        name: t.string,
    })),
    scheduleCargoTemplates: t.array(t.strict({
        id: t.string,
        scheduleId: nullable(t.string),
        ref: nullable(t.string),
    })),
});
export const extraCo2TypeInUseResT = t.strict({
    code: t.literal("ERR_EXTRA_CO2_TYPE_IN_USE"),
    usage: extraCo2TypeUsageT,
});
//# sourceMappingURL=extra-co2-types.js.map